export default __webpack_public_path__ + "static/media/like-white.75abf2a5.svg";